import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'ea-read-more-or-less',
	templateUrl: './read-more-or-less.component.html'
})
export class ReadMoreOrLessComponent implements OnInit {
	@Input() text: string;
	@Input() maxLength = 200;
	@Input() moreText = 'More';
	@Input() lessText = 'Less';
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() readonly onClick: EventEmitter<void> = new EventEmitter<void>();

	currentText = '';
	isCollapsed = false;
	showMoreLess = false;

	toggleView(): void {
		if (this.isCollapsed) {
			this.currentText = this.text;
			this.onClick.emit();
		} else {
			this.setTruncateText();
		}
		this.isCollapsed = !this.isCollapsed;
	}

	setTruncateText(): void {
		this.currentText = `${this.text.substring(0, this.maxLength)}...`;
	}

	ngOnInit(): void {
		if (this.text?.length >= this.maxLength) {
			this.isCollapsed = true;
			this.showMoreLess = true;
			this.setTruncateText();
		} else {
			this.currentText = this.text;
		}
	}
}
